import { IconPencil } from '@tabler/icons-react';
import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type IEditActionIconProps = Omit<IBasicActionIconProps, 'children'>;

const DefaultProps: Partial<IEditActionIconProps> = {
  color: 'blue',
};

/** @registry Blue "edit" action icon (pencil symbol) built on BasicActionIcon. */
export const EditActionIcon = React.forwardRef<
  HTMLButtonElement,
  IEditActionIconProps
>((props, ref) => {
  return (
    <BasicActionIcon {...DefaultProps} {...props} ref={ref}>
      <IconPencil size={20} />
    </BasicActionIcon>
  );
});
EditActionIcon.displayName = 'EditActionIcon';
